import { render, staticRenderFns } from "./FujiParts.vue?vue&type=template&id=24c41f25&scoped=true"
import script from "./FujiParts.vue?vue&type=script&lang=ts"
export * from "./FujiParts.vue?vue&type=script&lang=ts"
import style0 from "./FujiParts.vue?vue&type=style&index=0&id=24c41f25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c41f25",
  null
  
)

export default component.exports